// extracted by mini-css-extract-plugin
module.exports = {"chart-container":"StockCommodityScatterPlotChart_chart-container__CwjC9"};